import React from 'react';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

// Short labels for the radar chart
const SHORT_LABELS = {
  PERSIST: 'Persist',
  ACQUIRE: 'Acquire',
  AVOID: 'Avoid',
  OVERCOME: 'Overcome',
  SEEK: 'Seek',
  UNDERSTAND: 'Understand',
  EVALUATE: 'Evaluate',
  BOND: 'Bond',
  NURTURE: 'Nurture',
  BELONG: 'Belong',
  ASSERT: 'Assert',
  GROW: 'Grow',
  CREATE: 'Create',
  PLAY: 'Play',
  REPRODUCE: 'Reproduce',
  TRANSCEND: 'Transcend',
  DISSOLVE: 'Dissolve',
  MORAL_SENSE: 'Moral',
};

const VALENCE_COLORS = {
  POSITIVE: 'hsl(160, 84%, 60%)',    // emerald
  NEGATIVE: 'hsl(0, 84%, 60%)',      // red
  AMBIVALENT: 'hsl(45, 93%, 58%)',   // amber
};

export default function PrimitiveRadar({ primitives = [] }) {
  // Sort primitives into canonical order
  const orderedNames = Object.keys(SHORT_LABELS);

  const data = orderedNames.map((name) => {
    const p = primitives.find((x) => x.name === name);
    return {
      name: SHORT_LABELS[name] || name,
      fullName: name,
      activation: p?.activation || 0,
      valence: p?.valence || null,
    };
  });

  // Determine the dominant valence for fill color
  const topPrimitives = [...primitives].sort((a, b) => (b.activation || 0) - (a.activation || 0)).slice(0, 3);
  const dominantValence = topPrimitives[0]?.valence || 'POSITIVE';
  const fillColor = VALENCE_COLORS[dominantValence] || VALENCE_COLORS.POSITIVE;

  if (primitives.length === 0) {
    return (
      <div className="h-[300px] flex items-center justify-center text-muted-foreground text-sm">
        No primitive activations yet
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RadarChart data={data} cx="50%" cy="50%" outerRadius="75%">
        <PolarGrid
          stroke="hsl(var(--border))"
          strokeDasharray="3 3"
        />
        <PolarAngleAxis
          dataKey="name"
          tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 10 }}
        />
        <PolarRadiusAxis
          domain={[0, 1]}
          tick={false}
          axisLine={false}
        />
        <Radar
          dataKey="activation"
          stroke={fillColor}
          fill={fillColor}
          fillOpacity={0.15}
          strokeWidth={2}
          dot={{ r: 3, fill: fillColor, fillOpacity: 0.8 }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'hsl(var(--card))',
            border: '1px solid hsl(var(--border))',
            borderRadius: '8px',
            fontSize: '12px',
          }}
          formatter={(value, name, entry) => [
            `${(value * 100).toFixed(0)}%`,
            entry.payload.fullName,
          ]}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
}
